import React, { createContext, useContext, useState, useEffect } from 'react';

const StaffAuthContext = createContext();

export const useStaffAuth = () => {
  const context = useContext(StaffAuthContext);
  if (!context) {
    throw new Error('useStaffAuth must be used within StaffAuthProvider');
  }
  return context;
};

export const StaffAuthProvider = ({ children }) => {
  const [staff, setStaff] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for saved auth on mount
    const savedToken = localStorage.getItem('staff_token');
    const savedStaff = localStorage.getItem('staff_data');
    
    if (savedToken && savedStaff) {
      try {
        setToken(savedToken);
        setStaff(JSON.parse(savedStaff));
      } catch (e) {
        localStorage.removeItem('staff_token');
        localStorage.removeItem('staff_data');
      }
    }
    setLoading(false);
  }, []);

  const login = async (staff_id, password) => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    
    const response = await fetch(`${API_URL}/api/staff/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ staff_id, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }

    const data = await response.json();
    
    setToken(data.token);
    setStaff(data.staff);
    localStorage.setItem('staff_token', data.token);
    localStorage.setItem('staff_data', JSON.stringify(data.staff));
    
    return data;
  };

  const logout = () => {
    setToken(null);
    setStaff(null);
    localStorage.removeItem('staff_token');
    localStorage.removeItem('staff_data');
  };

  const getAuthHeaders = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <StaffAuthContext.Provider value={{
      staff,
      token,
      loading,
      isAuthenticated: !!token,
      login,
      logout,
      getAuthHeaders
    }}>
      {children}
    </StaffAuthContext.Provider>
  );
};

export default StaffAuthContext;
